"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Col3Col9 = void 0;
var aon_tws_common_ui_1 = require("@aon/aon-tws-common-ui");
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("..");
var TooltipContent_1 = require("../TooltipContent");
var Col3Col9Left = styled_components_1.default.div.attrs(function (props) { return ({
    className: 'tws-col3col9-left',
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
Col3Col9Left.displayName = 'Col3Col9Left';
var Col3Col9Right = styled_components_1.default.div.attrs(function (props) { return ({
    className: 'tws-col3col9-right',
}); })(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
Col3Col9Right.displayName = 'Col3Col9Right';
var ChildrenContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tcolor: #696969;\n"], ["\n\tcolor: #696969;\n"])));
ChildrenContainer.displayName = 'ChildrenContainer';
var Col3Col9 = /** @class */ (function (_super) {
    __extends(Col3Col9, _super);
    function Col3Col9() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Col3Col9.prototype.render = function () {
        return (React.createElement(__1.ClearDiv, { clearHeight: this.props.clearHeight, clearHeightMobile: this.props.clearHeightMobile, clearBefore: this.props.clearBefore, className: 'row ' + this.props.className },
            React.createElement(Col3Col9Left, { className: 'col-lg-3 col-sm-12' },
                this.props.label && (React.createElement(__1.Label, { size: this.props.labelSize, className: 'tws-label' },
                    this.props.label,
                    this.props.labelInfo !== undefined && (React.createElement(aon_tws_common_ui_1.Tooltip, { id: this.props.label + '-tooltip', contentType: 'html', wrapper: 'div' },
                        React.createElement(TooltipContent_1.TooltipContentWrapper, null,
                            this.props.labelInfoTitle !== undefined && React.createElement(TooltipContent_1.TooltipContentTitle, null, this.props.labelInfoTitle),
                            React.createElement("p", null, this.props.labelInfo)))))),
                this.props.subLabelDisplayData !== undefined && React.createElement("div", null, this.props.subLabelDisplayData)),
            React.createElement(Col3Col9Right, { className: 'col-lg-9 col-sm-12' },
                React.createElement(ChildrenContainer, null, this.props.children))));
    };
    Col3Col9.defaultProps = {
        labelSize: 'md',
    };
    return Col3Col9;
}(React.PureComponent));
exports.Col3Col9 = Col3Col9;
var templateObject_1, templateObject_2, templateObject_3;
